import type { GameKindAdapter } from "../shared/adapter";
import { compileQuiz } from "./compiler";
import { evaluateQuiz } from "./evaluator";
import { repairCommandsForQuiz } from "./repair";
import { parseQuizSpec, type QuizSpec } from "./spec";

export const quizAdapter: GameKindAdapter = {
  kind: "quiz",
  briefHints: ["quiz", "trivia", "questions about", "how much do you know", "test your knowledge"],
  promptSchemaLine:
    '{"kind":"quiz","params":{"questions":[{"prompt":"string max 140","answers":["string max 60","string max 60","string max 60","string max 60"],"correctIndex":integer 0-3}] (3-15 entries),"secondsPerQuestion":integer 5-30,"goalCorrect":integer 1 to number of questions,"players":1 or 2 (2 = pass-and-play, players alternate questions -- use an even question count)}}',
  parseSpec: parseQuizSpec,
  compile: (spec) => compileQuiz(spec as QuizSpec),
  evaluate: (spec) => evaluateQuiz(spec as QuizSpec),
  repairCommandsFor: (spec, failedReceipt) => repairCommandsForQuiz(spec as QuizSpec, failedReceipt),
};

export type { QuizSpec } from "./spec";
